export const LocalStorageKeys = {
  hasActivePayment: "has_active_payment",
  hasActiveSbpTransfer: "has_active_sbp_transfer",
};
